const AiChatRoleNames = {
  SYSTEM: "system",
  ASSISTANT: "assistant",
  USER: "user"
} as const;

export default AiChatRoleNames;
